<template>
    <div>
        <div style="margin-bottom:10px">
            <el-button 
                size="small" 
                type="primary" 
                @click="refresh()"
                icon="el-icon-refresh-right">
                    更新保证金状态
            </el-button>
        </div>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段编码" prop="bdcode" min-width="140" fixed="left"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="140"></el-table-column>
            <el-table-column label="开标时间" prop="extkbtime" min-width="140"></el-table-column>
            <el-table-column label="缴纳保证金家数" prop="bzjjlcount" width="140">
                <template slot-scope="scope">
                    <span v-if="scope.row.bzjjlcount < scope.row.showcount">
                        不足 {{scope.row.showcount}} 家
                    </span>
                    <span v-if="scope.row.bzjjlcount>= scope.row.showcount">
                        大于或等于 {{scope.row.showcount}} 家
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-view" @click="view(scope.row.bdcode)" v-if="scope.row.isshow">查看保证金记录</el-button>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/TouBiao/Bzj/bdlist.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {},
    data() {
        return{
            pgData: {
                zbprocode:this.getQuery('procode'),
                // sortname:'procode'
            },
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        view(bdcode) {
            this.goto({
                path:'./detail',
                query:{
                    bdcode:bdcode,
                }
            });
        },
        // 更新保证金状态
        refresh(){
            var that = this;
            that.$get(`${that.getGetters('bidUrl')}/TouBiao/Bzj/gxzt.json`, {
                zbprocode:that.getQuery('procode')
            }, (data, res) => {
                ShowMsg('更新保证金状态成功', 'success');
                that.reloadHandler();
            });
        }
    },
    created() {
       
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
